var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2501 14.1665C11.2501 14.8569 10.6904 15.4165 10.0001 15.4165C9.30973 15.4165 8.75008 14.8569 8.75008 14.1665C8.75008 13.4761 9.30973 12.9165 10.0001 12.9165C10.6904 12.9165 11.2501 13.4761 11.2501 14.1665Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41675 4.58317V7.91926C3.9471 7.98754 2.91675 9.31479 2.91675 10.7498V16.7498C2.91675 18.2233 4.00304 19.5832 5.5358 19.5832H14.4644C15.9971 19.5832 17.0834 18.2233 17.0834 16.7498V10.7498C17.0834 9.31479 16.0531 7.98754 14.5834 7.91926V4.58317C14.5834 3.4443 14.0736 2.37507 13.2054 1.60331C12.3403 0.834388 11.186 0.416504 10.0001 0.416504C8.81412 0.416504 7.65983 0.834388 6.79479 1.60331C5.92656 2.37507 5.41675 3.4443 5.41675 4.58317ZM10.0001 2.08317C9.19692 2.08317 8.44356 2.36767 7.90207 2.84899C7.36378 3.32747 7.08342 3.95393 7.08342 4.58317V7.9165H12.9167V4.58317C12.9167 3.95393 12.6364 3.32747 12.0981 2.84899C11.5566 2.36767 10.8032 2.08317 10.0001 2.08317ZM4.58341 10.7498C4.58341 10.0142 5.0961 9.58317 5.5358 9.58317H14.4644C14.9041 9.58317 15.4167 10.0142 15.4167 10.7498V16.7498C15.4167 17.4855 14.9041 17.9165 14.4644 17.9165H5.5358C5.0961 17.9165 4.58341 17.4855 4.58341 16.7498V10.7498Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9d4add86f017294990f9e3317094f11b.svg";
export { ForwardRef as ReactComponent };